import React, { useState } from 'react';
import { Drawer, List, Button, Select, message } from 'antd';
import {
  useCreateNakshatramCalendarEntry,
  useDeleteNakshatramCalendarEntry,
} from '../../services/nakshatram/calendar/nakshatram-calendar.service.hook';
import { useGetAllNakshatrams } from '../../services/nakshatram/nakshatram.service.hook';

const TmsNakshatramCalendarDrawer = ({
  visible,
  onClose,
  selectedDate,
  currentDateData,
}) => {
  const [newSelectedNakshatrams, setNewSelectedNakshatrams] = useState([]);

  const { data: nakshatramData } = useGetAllNakshatrams(1, 1000);

  const { mutate: createNakshatramCalendarEntry, isPending: createLoading } =
    useCreateNakshatramCalendarEntry();
  const { mutate: deleteNakshatram, isPending: deleteLoading } =
    useDeleteNakshatramCalendarEntry();

  const handleAddNakshatram = () => {
    if (newSelectedNakshatrams?.length) {
      createNakshatramCalendarEntry(
        { date: selectedDate, nakshatramIds: newSelectedNakshatrams },
        {
          onSuccess: () => {
            message.success('Nakshatram added successfully');
            // Refetch or update the state to reflect changes
          },
          onError: () => {
            message.error('Failed to add nakshatram');
          },
        }
      );
    }
  };

  const handleDeleteNakshatram = (nakshatramCalendarId) => {
    deleteNakshatram(
      { nakshatramCalendarId },
      {
        onSuccess: () => {
          message.success('Nakshatram deleted successfully');
          // Refetch or update the state to reflect changes
        },
        onError: () => {
          message.error('Failed to delete nakshatram');
        },
      }
    );
  };

  return (
    <Drawer
      title={`Nakshatram for ${selectedDate}`}
      placement='right'
      onClose={onClose}
      open={visible}
      destroyOnClose
    >
      <List
        loading={createLoading || deleteLoading}
        dataSource={currentDateData}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Button
                key={item.id}
                type='link'
                onClick={() => handleDeleteNakshatram(item.id)}
                style={{ color: 'red' }}
              >
                Delete
              </Button>,
            ]}
          >
            {item.nakshatram?.name}
          </List.Item>
        )}
      />
      <Select
        placeholder='Select Nakshatram'
        mode='multiple'
        onChange={(value) => setNewSelectedNakshatrams(value)}
        style={{ width: '100%', marginBottom: 16 }}
        options={nakshatramData?.items?.map((nakshatram) => ({
          label: nakshatram.name,
          value: nakshatram.id,
        }))}
      />
      <Button
        type='primary'
        onClick={handleAddNakshatram}
        style={{ width: '100%' }}
        loading={createLoading || deleteLoading}
      >
        Add Nakshatram
      </Button>
    </Drawer>
  );
};

export default TmsNakshatramCalendarDrawer;
